import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ApiKey } from 'api/api-keys';
import { Button } from 'components/atoms/button';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { Loading } from 'components/atoms/loading';
import { Modal } from 'components/atoms/modal';
import { useTranslation } from 'hooks/use-translation';

interface ModalProps {
  visible: boolean;
  submit: (apiKeyName: string) => void;
  closeModal: () => void;
  isCreating: boolean;
  keys: ApiKey[] | undefined;
}

const RightSide = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const NewApiKeyModal: FC<ModalProps> = ({
  visible,
  submit,
  closeModal,
  isCreating,
  keys,
}) => {
  const sameNameExists = useTranslation(
    'settings.new.api.key.same.name.exists',
  );

  const requiredMessage = useTranslation('input.required');

  return (
    <Modal
      zIndex={1051}
      centered
      visible={visible}
      footer={null}
      title={<FormattedMessage id="settings.create.api.key" />}
      onCancel={closeModal}
    >
      <Form
        layout="vertical"
        onFinish={(values: any) => {
          submit(values.newApiKey);
        }}
      >
        <Form.Item
          label="API key name"
          name="newApiKey"
          rules={[
            { required: true, message: requiredMessage },
            () => ({
              validator(_, value) {
                if (keys?.some((key) => key.apiKeyName === value)) {
                  return Promise.reject(new Error(sameNameExists));
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input placeholder="API key name" name="newApiKey" type="text" />
        </Form.Item>
        <Form.Item>
          <RightSide>
            {isCreating ? (
              <Loading />
            ) : (
              <Button type="primary" htmlType="submit">
                <FormattedMessage id="add" />
              </Button>
            )}
          </RightSide>
        </Form.Item>
      </Form>
    </Modal>
  );
};
